<template>
  <div class="member-grade-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="140px">
      <el-form-item label="会员等级" prop="sortIndex">
        <el-select v-model="form.sortIndex" placeholder="请选择会员等级">
          <el-option v-for="(item, index) in sortIndexOption" :label="item.desc" :value="item.code" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入等级名称" class="input" />
      </el-form-item>
      <div v-if="form.sortIndex !== 1">
        <el-form-item label="升级条件（选填）" prop="upgradeCondition">
          <el-radio-group v-model="form.upgradeCondition.condition">
            <el-radio label="amount">交易金额</el-radio>
            <el-radio label="point">积分获取</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="condition">
          <div class="condition-item" v-for="(renderItem, renderIndex) in upgradeRender" :key="renderIndex">
            <el-form-item
              :label="form.upgradeCondition.condition == 'amount' ? renderItem.label_amount : renderItem.label_point"
              :prop="renderItem.paramsName + '_rangeCond'"
            >
              <el-select v-model="form.upgradeCondition[form.upgradeCondition.condition][renderItem.paramsName]['rangeCond']" placeholder="请选择" clearable>
                <el-option v-for="item in conditionRange" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" :prop="renderItem.paramsName + '_begin'" label-width="0">
              <el-input v-model="form.upgradeCondition[form.upgradeCondition.condition][renderItem.paramsName]['begin']" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" />
            </el-form-item>
            <div class="text">升级</div>
          </div>
        </div>
        <el-form-item label="保级条件" prop="relegateCondition">
          <el-radio-group v-model="form.relegateCondition.condition">
            <el-radio label="naturalYear">自然年度</el-radio>
            <el-radio label="upgradeDate">升级日起</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="condition">
          <div class="condition-item" v-for="(renderItem, renderIndex) in relegateRender" :key="renderIndex">
            <el-form-item
              :label="form.relegateCondition.condition == 'naturalYear' ? renderItem.label_amount : renderItem.label_point"
              :prop="renderItem.paramsName + '_rangeCond'"
            >
              <el-select v-model="form.relegateCondition[form.relegateCondition.condition][renderItem.paramsName]['rangeCond']" placeholder="请选择" clearable>
                <el-option v-for="item in conditionRange" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" :prop="renderItem.paramsName + '_begin'" label-width="0">
              <el-input v-model="form.relegateCondition[form.relegateCondition.condition][renderItem.paramsName]['begin']" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" />
            </el-form-item>
            <div class="text hold">保级，否则降级</div>
          </div>
        </div>
      </div>
      <el-form-item label="等级LOGO" prop="logo">
        <UploadImg @getUploadFile="(file) => {getUploadFile(file, 'logo')}" :uploadUrl="form.logo" :desc="'建议：上传20*20的jpg、 png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="等级背景" prop="background">
        <UploadImg @getUploadFile="(file) => {getUploadFile(file, 'background')}" :uploadUrl="form.background" :desc="'建议：上传345*120的jpg、 png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="会员权益" prop="privilegeIds">
        <el-select v-model="form.privilegeIds" placeholder="请选择会员权益" multiple>
          <el-option v-for="(item, index) in privilegeOption" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div class="optional">（选填）</div>
      </el-form-item>
      <el-form-item label="等级说明" prop="remark">
        <el-input type="textarea" rows="6" v-model="form.remark" placeholder="请输入等级说明" maxlength="80" show-word-limit />
        <div class="optional">（选填）</div>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { api_getMemberLevel, api_getMemberSortIndex, api_postMemberLevel, api_putMemberLevel } from '@/api/member'
import { api_postFileUpload, api_getListBenefit } from '@/api/common'
export default {
  name: "memberGradeAdd",
  components: {
    UploadImg
  },
  data() {
    // 校验升级条件和保级条件  范围选项和输入框 两者要么都填，要么都不填
    const checkRangeCond = (rule, value, callback) => {
      const { field } = rule
      const item = field.split('_')[0]
      const prop = field.split('_')[1]
      const formField = item == 'amount' || item == 'point' ? 'relegateCondition' : 'upgradeCondition'
      const { condition } = this.form[formField]
      const v = this.form[formField][condition][item][prop]
      if (!v && prop == 'rangeCond' && this.form[formField][condition][item].begin) {
        callback(new Error('请选择'))
      } else if (!v && prop == 'begin' && this.form[formField][condition][item].rangeCond) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    // 校验升级、保级条件 至少填入一项
    const checkCondition = (rule, value, callback) => {
      const { field } = rule
      let curField = this.form[field]
      const curParams = curField[curField.condition]
      const { amount, point, daily, monthly, annually } = curParams
      if (field == 'relegateCondition' && !amount.rangeCond && !amount.begin && !point.rangeCond && !point.begin) {
        callback(new Error('保级条件至少填入一项'))
      } else if (field == 'upgradeCondition' && !daily.rangeCond && !daily.begin && !monthly.rangeCond && !monthly.begin && !annually.rangeCond && !annually.begin) {
        callback(new Error('升级条件至少填入一项'))
      } else {
        callback()
      }
    }
    return {
      form: {
        name: '',
        privilegeIds: [],
        logo: '',
        background: '',
        remark: '',
        upgradeCondition: {
          condition: 'amount',
          amount: { daily: {}, monthly: {}, annually: {}, },
          point: { daily: {}, monthly: {}, annually: {}, }
        },
        relegateCondition: {
          condition: 'naturalYear',
          naturalYear: { amount: {}, point: {}, },
          upgradeDate: { amount: {}, point: {}, }
        },
        sortIndex: '',
      },
      rules: {
        name: [{ required: true, message: '请输入等级名称' }],
        logo: [{ required: true, message: '请上传等级LOGO' }],
        background: [{ required: true, message: '请上传等级背景' }],
        upgradeCondition: [
          { required: true, message: '请选择升级条件' },
          { validator: checkCondition }
        ],
        relegateCondition: [
          { required: true, message: '请选择保级条件' },
          { validator: checkCondition }
        ],
        sortIndex: [{ required: true, message: '请选择会员等级' }],
        daily_rangeCond: [{ validator: checkRangeCond }],
        monthly_rangeCond: [{ validator: checkRangeCond }],
        annually_rangeCond: [{ validator: checkRangeCond }],
        daily_begin: [{ validator: checkRangeCond }],
        monthly_begin: [{ validator: checkRangeCond }],
        annually_begin: [{ validator: checkRangeCond }],

        amount_rangeCond: [{ validator: checkRangeCond }],
        point_rangeCond: [{ validator: checkRangeCond }],
        amount_begin: [{ validator: checkRangeCond }],
        point_begin: [{ validator: checkRangeCond }],
      },
      conditionRange: [
        {value: 'greaterAndEquals', name: '大于等于'},
        {value: 'equals', name: '等于'},
        {value: 'greater', name: '大于'},
      ],
      upgradeRender: [
        {label_amount: '日消费金额', label_point: '日获取积分', paramsName: 'daily'},
        {label_amount: '或月消费金额', label_point: '或月获取积分' , paramsName: 'monthly'},
        {label_amount: '或年消费金额', label_point: '或年获取积分' , paramsName: 'annually'},
      ],
      relegateRender: [
        {label_amount: '自然年度消费金额', label_point: '365日内消费金额', paramsName: 'amount'},
        {label_amount: '或自然年度积分获取', label_point: '或365日内获取积分', paramsName: 'point'},
      ],
      sortIndexOption: [],
      privilegeOption: [],
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.title = '编辑等级'
      this.id = this.$route.query.id
      this.getDetailDate() // 获取详情数据
    } else {
      this.$route.meta.title = '创建等级'
    }
    this.getSortIndex() // 获取等级排序
    this.getListBenefit() // 获取权益类标
  },
  methods: {
    async getListBenefit () {
      const data = await api_getListBenefit()
      this.privilegeOption = data.map((item) => {
        return {
          label: item.name,
          value: item.id
        }
      })
    },
    async getSortIndex () {
      this.sortIndexOption = await api_getMemberSortIndex()
    },

    getUploadFile (file, key) {
      this.form[key] = file
    },
    // 获取详情数据
    async getDetailDate() {
      const data = await api_getMemberLevel({id: this.$route.query.id})
      data.privilegeIds = JSON.parse(data.privilegeIds)

      // 处理升级条件、保级条件数据
      data.upgradeCondition = data.upgradeCondition ? JSON.parse(data.upgradeCondition) : {}
      data.relegateCondition = data.relegateCondition ? JSON.parse(data.relegateCondition) : {}
      data.upgradeCondition = {
        ...this.form.upgradeCondition,
        ...data.upgradeCondition,
        condition: Object.keys(data.upgradeCondition)[0] || this.form.upgradeCondition.condition
      }
      data.relegateCondition = {
        ...this.form.relegateCondition,
        ...data.relegateCondition,
        condition: Object.keys(data.relegateCondition)[0] || this.form.relegateCondition.condition
      }
      console.log('详情data: ', data);
      let { name, logo, background, remark, upgrade, sortIndex, privilegeIds, upgradeCondition, relegateCondition } = data
      this.form = { name, logo, background, remark, upgrade, sortIndex, privilegeIds, upgradeCondition, relegateCondition }
    },

    // 点击提交按钮
    onSubmit() {
      console.log('form', this.form);
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
          }
          try {
            // 处理升降级条件
            params.upgradeCondition = JSON.stringify({[params.upgradeCondition.condition]: params.upgradeCondition[params.upgradeCondition.condition]})
            params.relegateCondition = JSON.stringify({[params.relegateCondition.condition]: params.relegateCondition[params.relegateCondition.condition]})

            // console.log('params-after: ', params);
            // this.submitLoading = false
            // return
            let uploadArr = [{name: 'logo', key: 'LevelLogo'}, {name: 'background', key: 'LevelBackground'}]
            for(let i in uploadArr) {
              let item = uploadArr[i]
              if (this.form[item.name].size) {
                const { key } = await api_postFileUpload(this.form[item.name], item.key)
                params[item.name] = key
              }
            }

            this.$route.query.id ? await api_putMemberLevel({...params, id: this.$route.query.id}) : await api_postMemberLevel(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.member-grade-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }

  .condition {

    .condition-item {
      display: flex;
      .el-select {
        width: 180px;
        margin-right: 2px;
      }
      .el-input {
        width: 168px;
      }

      .text {
        height: 34px;
        line-height: 34px;
        padding-left: 10px;
      }
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
